import { getJson } from "../utils/apiServiceBase";
import { cops } from "../models/copsdata"

export async function getCOPSMultitenants(): Promise<cops[]> {
    return await getJson<cops[]>("api/Alerting");
}